import { connect } from 'react-redux';
import { utils, Loader } from "@mc/mc-legacy";
import OrderPage from "./OrderPage";
import ZakazkaForm, {FIELD_PREFIX_UKON} from "../../../forms/ZakazkaForm";
import ObjednavkaCustomApi from "../../../api/ObjednavkaCustomApi";
import * as localStorageUtils from "../../../utils/localStorageUtils";
import { withRouter } from "react-router";
import { SubmissionError } from "redux-form";
import * as ciselnikActions from "../../../actions/ciselnikActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import { redirectToOrderStepNumber } from "../../../utils/utils";
import * as opravneniActions from "../../../actions/opravneniActions";
import {CAS_ROZPRACOVANI_KEY} from "../../../const/const";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const CURRENT_STEP = 1;

/**
 * Stránka procesu objednávky - Zakázka.
 */
class ZakazkaPage extends Component<WithTranslation> {

    unsavedData = null;

    componentDidMount() {
        this.fetchData();
        this.saveTimeIfNeeded();
    }

    componentDidUpdate() {
        this.fetchData();
        this.saveTimeIfNeeded();
    }

    componentWillUnmount() {
        const { loggedInUser } = this.props;
        if (this.unsavedData) {
            this.saveData(this.unsavedData);
            this.props.dispatch(objednavkaActions.invalidateDataZakazka());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        }
    }

    fetchData = () => {
        const { loggedInUser } = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchUkonyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchSouborAtributyIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            this.props.dispatch(objednavkaActions.fetchDataZakazkaIfNeeded(loggedInUser.data.id));
            this.props.dispatch(objednavkaActions.fetchCasRozpracovaniObjednavky(loggedInUser.data.id));
        }
    };

    /**
     * Zkontroluje, zda je uložen čas rozpracování objednávky a pokud ne, nastaví jej na současný čas.
     */
    saveTimeIfNeeded = () => {
        const {loggedInUser, casRozpracovaniObjednavky} = this.props;
        if (casRozpracovaniObjednavky.fetched && !casRozpracovaniObjednavky.isFetching && !casRozpracovaniObjednavky.data) {
            localStorageUtils.save(loggedInUser.data.id, CAS_ROZPRACOVANI_KEY, Date.now());
            this.props.dispatch(objednavkaActions.invalidateCasRozpracovaniObjednavky(loggedInUser.data.id));
        }
    };

    /**
     * Vrací promise. Provede nahrání nových souborů ve formuláři na server a vrátí upravená data s dočasnými kódy pro tyto soubory.
     * Pokud nejsou k nahrání žádné nové soubory, vrátí původní data.
     *
     * @param formValues data formuláře
     * @returns {Promise<any>}
     */
    // TODO berka pravděpodobně se už nepoužívá, resp. volá se ale není potřeba - prověřit
    uploadNoveSoubory = (formValues) => {
        return new Promise(resolve => {
            if (formValues.fileMetas && formValues.fileMetas.length !== 0) {
                const newMetas = formValues.fileMetas.filter(fileMeta => fileMeta.file);
                const tempSoubory = newMetas.map(fileMeta => fileMeta.file);
                if (tempSoubory.length !== 0) { // Nové soubory k uploadu
                    return ObjednavkaCustomApi.createTempSoubory(tempSoubory).then(result => {
                        const updatedMetas = newMetas.map(fileMeta => {
                            return {
                                attributes: { ...fileMeta.attributes },
                                name: fileMeta.file.name,
                                code: result[fileMeta.file.name],
                            }
                        });
                        const oldMetas = formValues.fileMetas.filter(fileMeta => fileMeta.name);
                        const storedMetas = [...oldMetas, ...updatedMetas];
                        resolve({ ...formValues, fileMetas: storedMetas });
                    });
                } else {
                    resolve(formValues);
                }
            } else {
                resolve(formValues);
            }
        });
    };

    saveData = (data) => {
        const { loggedInUser } = this.props;
        localStorageUtils.saveOrderData(loggedInUser.data.id, CURRENT_STEP, data);
        this.unsavedData = null;
    };

    invalidateAndContinue = () => {
        const { loggedInUser } = this.props;
        this.props.dispatch(objednavkaActions.invalidateDataZakazka());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastFinishedStep(loggedInUser.data.id));
        redirectToOrderStepNumber(CURRENT_STEP + 1, this.props);
    };

    render() {
        const { loggedInUser, ukonyList, souborAtributyList, zakazkaData, t} = this.props;

        if (!loggedInUser.fetched || !ukonyList.fetched || !souborAtributyList.fetched || !zakazkaData.fetched) {
            return <Loader />;
        }

        // Initial values - implicitně vždy první hodnota, která se případně přepíše dříve uloženými daty objednávky
        const tmpValues = {
            pocetVyhotoveni: 1,
        };
        for (let ukon of ukonyList.rows) {
            if (ukon.polozky.length > 0) {
                tmpValues[`${FIELD_PREFIX_UKON}${ukon.id}`] = ukon.polozky[0];
            }
        }
        // TODO implicitní hodnoty pro atributy souborů se zatím nastavují ve FileUploadPanel, jelikož zatím je to trochu hovnokód a v tuhle chvíli netuším jak to udělat lépe
        const initialValues = { ...tmpValues, ...zakazkaData.data };

        return <OrderPage title={t('pages.main.title')} subtitle={t('order.new')} currentStep={CURRENT_STEP}>
            <ZakazkaForm
                onSubmit={data => {
                    return new Promise((resolve, reject) => {
                        // Validace počtu souborů
                        if (!loggedInUser.data.rgObjednavBezSouboru && (!data.fileMetas || data.fileMetas.length === 0)) {
                            const errors = {
                                _error: t('validation.min_one_file_required')
                            };
                            reject(new SubmissionError(errors));
                        }
                        // Validace vyplnění povinných atributů
                        const missingAttributes = [];
                        if (data.fileMetas) {
                            data.fileMetas.forEach(fileMeta => {
                                souborAtributyList.rows.forEach(souborAtribut => {
                                    if (souborAtribut.povinne) {
                                        if (!fileMeta.attributes[souborAtribut.id] || fileMeta.attributes[souborAtribut.id] === null) {
                                            missingAttributes.push(souborAtribut.nazevAtribut);
                                        }
                                    }
                                });
                            });
                        }
                        if (missingAttributes.length > 0) {
                            const errors = {
                                _error: t('validation.attributes_required',{missingAttributes: missingAttributes.join(", ")})
                            };
                            reject(new SubmissionError(errors));
                        }

                        this.uploadNoveSoubory(data).then((newData) => {
                            this.saveData({ ...newData, finished: true });
                            resolve();
                        });
                    });
                }}
                onSubmitSuccess={this.invalidateAndContinue}
                onChange={(data) => this.unsavedData = data}
                initialValues={initialValues}
                ukonyList={ukonyList.rows}
                souborAtributyList={souborAtributyList.rows}
            />
        </OrderPage>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        ukonyList: utils.storeFromArea(state, ciselnikActions.UKONY_LIST_AREA),
        souborAtributyList: utils.storeFromArea(state, ciselnikActions.SOUBOR_ATRIBUTY_LIST_AREA),
        zakazkaData: utils.storeFromArea(state, objednavkaActions.ZAKAZKA_DETAIL_AREA),
        casRozpracovaniObjednavky: utils.storeFromArea(state, objednavkaActions.CAS_ROZPRACOVANI_DETAIL_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ZakazkaPage)));
